/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CriteriaUser } from '../../models/criteria-user';
import { ManageUserProfile } from '../../models/manage-user-profile';

export interface ApiUserAllUserPost$Params {
      body?: CriteriaUser
}

export function apiUserAllUserPost(http: HttpClient, rootUrl: string, params?: ApiUserAllUserPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ManageUserProfile>>> {
  const rb = new RequestBuilder(rootUrl, apiUserAllUserPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ManageUserProfile>>;
    })
  );
}

apiUserAllUserPost.PATH = '/api/User/AllUser';
